import { useMemo } from "react"
import { Box } from "@mui/material"
import { Business as ManufacturerIcon } from '@mui/icons-material';
import { ManufacturerResult, useGetManufacturerLogo } from "interface/manufacturer"

export const ManufacturerOption = ({
  manufacturer,
  ...props
}: {
  manufacturer: ManufacturerResult
} & React.HTMLAttributes<HTMLLIElement>) => {
  const manufacturerLogoState = useGetManufacturerLogo(manufacturer.manufacturerId, manufacturer.updateTime)
  const manufacturerLogo = useMemo(
    () => manufacturerLogoState.data?.blob ? URL.createObjectURL(manufacturerLogoState.data.blob) : null,
    [manufacturerLogoState]
  )
  return (
    <Box
      component="li"
      sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
      {...props}
    >
      { manufacturerLogo ? (
        <img
          alt={manufacturer?.manufacturerName ?? 'manufacturers logo'}
          src={manufacturerLogo}
          width="32"
        />
      ) : (
        <ManufacturerIcon fontSize="medium" color="disabled" sx={{ marginRight: 1 }}/>
      )}
      {manufacturer.manufacturerName}
    </Box>
  )
}
